export { default } from './BatchActionLink';



// WEBPACK FOOTER //
// ./app/components/shared/BatchActions/BatchActionLink/index.js